import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';
import { AdviserConfigurationInstruction } from '../../Models/Models/Adviser/Configuration/AdviserConfigurationInstruction';
import { AdviserConfigurationInstructionUpdateAction } from '../../Constants/Enums/Domain/AdviserConfigurationInstructionUpdateAction';

declare var IS_RUNNING_IN_APP_POOL;

export class UpdateAdviserConfigurationInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(adviserConfigurationInstruction: AdviserConfigurationInstruction, adviserConfigurationInstructionUpdateAction: AdviserConfigurationInstructionUpdateAction): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Adviser/UpdateAdviserConfigurationInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { adviserConfigurationInstruction: adviserConfigurationInstruction, adviserConfigurationInstructionUpdateAction: adviserConfigurationInstructionUpdateAction }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

